import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './ProductsGrid.css';


const ProductsGrid = () => {
  const navigate = useNavigate();

  const [categories, setCategories] = useState([]);



  const [brands, setBrands] = useState([]);

  // Fetch categories from API
  useEffect(() => {
    fetch('https://kingsolarman.pythonanywhere.com/api/categories/')
      .then(res => res.json())
      .then(data => {
        const categoriesData = data.results || data;

        // Filter to only show specific categories and sort by product count
        const targetCategories = ['accessories', 'batteries', 'solar_inverters', 'solar_panels'];
        const filteredCategories = categoriesData
          .filter(category => category.is_active && targetCategories.includes(category.name))
          .sort((a, b) => b.product_count - a.product_count); // Sort by product count (descending)

        setCategories(filteredCategories);
      })
      .catch(error => {
        console.error('Error fetching categories:', error);

        // Fallback to default categories (only the 4 target categories)
        setCategories([
          {
            id: 'accessories',
            name: 'accessories',
            display_name: 'Accessories',
            image: '/images/brands/Accessories.png'
          },
          {
            id: 'batteries',
            name: 'batteries',
            display_name: 'Batteries',
            image: '/images/brands/Battery.png'
          },
          {
            id: 'solar_inverters',
            name: 'solar_inverters',
            display_name: 'Solar Inverters',
            image: '/images/brands/Inverter.png'
          },
          {
            id: 'solar_panels',
            name: 'solar_panels',
            display_name: 'Solar Panels',
            image: '/images/brands/solar panel.png'
          }
        ]);
      });
  }, []);




  useEffect(() => {
    // Always show exactly these 5 brands (no API call to avoid showing too many)
    const staticBrands = [
      { id: 'luxpower', name: 'Luxpower', displayName: 'LuxPower', logo: '/images/brands/Luxpower.avif' },
      { id: 'deye', name: 'Deye', displayName: 'Deye', logo: '/images/brands/deye.avif' },
      { id: 'renusol', name: 'RENUSOL', displayName: 'RENUSOL', logo: '/images/brands/Renusol.avif' },
      { id: 'jinko', name: 'Jinko Solar', displayName: 'Jinko Solar', logo: '/images/brands/jinko.avif' },
      { id: 'dyness', name: 'DYNESS', displayName: 'DYNESS', logo: '/images/brands/Dyness.avif' }
    ];

    // Always set exactly 5 brands - no API call to avoid issues
    setBrands(staticBrands);
  }, []);

  return (
    <div className="products-grid-container">
      {/* Categories Section */}
      <section className="categories-section">
        <div className="container">
          <div className="categories-header">
            <h2>Product Categories</h2>
            <p className="categories-subtitle">Browse our wide range of solar energy products</p>
          </div>

          <div className="categories-grid">
            {categories.map((category, index) => {
              const catName =
                category.display_name ||
                (typeof category.name === 'string'
                  ? category.name.replace(/_/g, ' ').toUpperCase()
                  : 'Unknown Category');
              const catId = category.id || `category-${index}`;
              const catImg = category.image || null;
              
              // Ensure unique key by combining id with index
              const uniqueKey = `cat-${catId}-${index}`;
              
              return (
                <div
                  key={uniqueKey}
                  className="category-card"
                  style={{
                    cursor: 'pointer',
                    width: 240,
                    height: 280,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxSizing: 'border-box',
                  }}
                  onClick={() => navigate(`/products?category=${catId}`)}
                >
                  <div className="category-icon" style={{ marginBottom: 12 }}>
                    {catImg && (
                      <img src={catImg} alt={catName} className="category-img" style={{ width: 200, height: 200, objectFit: 'contain' }} />
                    )}
                  </div>
                  <h3 className="category-name">{catName}</h3>
                </div>
              );
            })}
          </div>
        </div>
      </section>


      {/* Brands Section */}
      <section className="brands-section">
        <div className="container">
          <div className="brands-header">
            <h2>BRANDS</h2>
              <p className="categories-subtitle">Filter with the brands we support and recommend</p>
      
          </div>

          <div className="brands-grid">
            {brands.map((brand, index) => {
              const brandImg = brand.logo || brand.image || null;
              const brandId = brand.id || `brand-${index}`;
              const uniqueKey = `brand-${brandId}-${index}`;
              
              return (
                <div
                  key={uniqueKey}
                  className="brand-card"
                  style={{ cursor: brandImg ? 'pointer' : 'default' }}
                  onClick={() => brandImg && navigate(`/products?brand=${brandId}`)}
                >
                  <div className="brand-logo">
                    {brandImg && (
                      <img src={brandImg} alt={brand.name || 'Brand'} className="brand-img" style={{ width: 100, height: 100, objectFit: 'contain' }} />
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProductsGrid;